import { useState, useEffect } from "react";
import { TextField, Button, Typography, Container, Box, Link, IconButton, InputAdornment } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { register, verifyOtp } from '../../services/auth'

const ResendOTP = () => {
    const [timeLeft, setTimeLeft] = useState(60);
    const [disabled, setDisabled] = useState(true);
  
    useEffect(() => {
      if (timeLeft > 0) {
        const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
        return () => clearTimeout(timer);
      } else {
        setDisabled(false);
      }
    }, [timeLeft]);
  
    const handleResendOTP = () => {
      console.log("Resending OTP...");
      if (!disabled) {
        setTimeLeft(60); // Reset timer
        setDisabled(true); // Disable button again
      }
    };
  
    return (        
          <Typography onClick={handleResendOTP} disabled={disabled} variant="body2" sx={{ mt: 1, textAlign: 'right', color: disabled? 'grey' : 'black', cursor: disabled? 'wait' : 'pointer'  }}>
            {disabled ? `Resend OTP in ${timeLeft} seconds` : `Resend OTP`}
          </Typography>        
    );
  };

const Register = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [validationErrors, setValidationErrors] = useState({})
  const navigate = useNavigate();

  const handleSendOtp = async() => {
    if (!validationErrors.phone && name && phone)  {
      const userData = await register(phone, name)
      console.log(userData)
      setOtpSent(true);
    } else {
      console.log('error')
    }
  };

  const handleRegister = async(e) => {
    e.preventDefault();    
    const verifyData = await verifyOtp(phone,otp)
    navigate('/set-password',  { state: { phone: phone, token:  verifyData.accessToken } })
    // Add registration logic here
  };

  return (
    <Container maxWidth="xs">
         <Box sx={{ mt: 2 }}>
            <IconButton onClick={()=>{navigate(-1)}}><ArrowBackIcon/></IconButton>
        </Box>
      <Box sx={{ mt: 8, p: 3, boxShadow: 3, borderRadius: 2, textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          Register
        </Typography>
          <TextField
            label="Full Name"
            fullWidth
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <TextField
            label="Phone Number"
            type="tel"
            fullWidth
            margin="normal"
            value={phone}
            error={validationErrors.phone}
            onChange={(e) => {
                const phonePattern = /^[6-9]\d{9}$/;
                setPhone(e.target.value)
                setValidationErrors({...validationErrors, phone: !phonePattern.test(e.target.value)});
            }}
            required
            slotProps={{
                input: {
                  startAdornment: <InputAdornment position="start">+91</InputAdornment>,
                },
              }}
          />
          {!otpSent && (<Button
            variant="outlined"
            fullWidth
            sx={{ mt: 1 }}
            onClick={handleSendOtp}
            disabled={!(name && phone) || validationErrors.phone}
          >
            {otpSent ? "OTP Sent" : "Send OTP"}
          </Button>)}
          {otpSent && (
            <TextField
              label="Enter OTP"
              fullWidth
              margin="normal"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
          )}
          {otpSent && <ResendOTP/>}
          <Button onClick={handleRegister} type="submit" variant="contained" disabled={!otp || otp.length < 6 } fullWidth sx={{ mt: 2 }}>
            Register
          </Button>
        <Typography variant="body2" sx={{ mt: 2 }}>
          Already have an account?{" "}
          <Link onClick={() => navigate("/login")} sx={{ cursor: "pointer" }}>
            Login
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default Register;
